import styled from "styled-components"
import { Modal } from "semantic-ui-react"

export const ReturnModalContent = styled(Modal.Content)`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`
